import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";

// const debug = "PublicSharingModule"
const debug = false

export class PublicSharingModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.PUBLIC_SHARING, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                        = "Public sharing"
        this.description                 = "The Public Sharing module enables users to share any view within the platform with anyone, including those without a GoodDay account, via a secure link. This feature promotes efficient collaboration and communication by facilitating the seamless sharing of relevant information with external stakeholders or collaborators."
        this.svgIcon                     = "isvg-public-sharing"
        this.settingsMenuTopCategory     = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                   = "Core"
        this.settingsUrl                 = "settings/public-sharing"
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}